import axios from 'axios'

const SET_SERVICE_LINKS = 'SET_SERVICE_LINKS'
const RESET = 'RESET'
const GET_LINKED_SERVICES_URL = 'api/ServiceRegistry/LinkedServices/'
const GET_SERVICE_BY_LINK_URL = (serviceLink) => `api/ServiceRegistry/LinkedServices/${serviceLink}`

export const SERVICE_LINKS = {
  DISCRETE_DATA_QUERY_REPORT: 'discrete_data_query_report',
  DISCRETE_IMPORT_EXCEEDANCE_NOTIFICATIONS: 'discrete_import_exceedance_notifications',
  VEGETATIVE_MONITORING_QUERY_REPORT: 'vegetative_monitoring_query_report',
  AQUARIUS_SYNCHRONIZER: 'aquarius_synchronizer',
  EQUIPMENT_TRACKER: 'equipment_tracker',
  HATFIELD_EDD_INGESTION: 'hatfield_edd_ingestion',
  A125_IMPORTER: 'a125_importer',
  ECOSURVEY_EDD_INGESTION: 'ecosurvey_edd_ingestion',
}

let initialState = () => ({
  services: [],
  serviceLinks: [],
})

export default {
  namespaced: true,
  state: initialState,
  actions: {
    async getLinkedServices({ commit }) {
      try {
        let response = await axios.get(GET_LINKED_SERVICES_URL)
        let serviceLinks = response.data
        commit(SET_SERVICE_LINKS, serviceLinks)
        return serviceLinks
      } catch (error) {
        throw error.response.data
      }
    },
    async getServiceByLink(_, {
      serviceLink,
    }) {
      if (!serviceLink) throw 'Must provide a service link'

      try {
        let response = await axios.get(GET_SERVICE_BY_LINK_URL(serviceLink))
        return response.data
      } catch (error) {
        return error.response.data
      }
    },

  },
  mutations: {
    [SET_SERVICE_LINKS](state, serviceLinks) {
      state.serviceLinks = serviceLinks
    },
    [RESET](state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
  },
  getters: {},
}